// cSpell: disable
/* Code provided by DSI and Luis (adjusted for TS) */
// Generates a hashed browser identifier by combining username + browser details
// (plugins, screen size, language, platform, timezone) and hashing the result.
export function getCookieCifra(username: string | null = '') {
	let stringPlugins = '';

	for (let n = 0; n < navigator.plugins.length; n++) {
		//PF: encode plugin description in order to treat the html present in the description of some plugins

		// const pluginDescription = $('<div/>').text(navigator.plugins[n].description).html();

		const div = document.createElement('div');
		div.textContent = navigator.plugins[n].description;
		const htmlContent = div.innerHTML;

		stringPlugins += ';' + htmlContent;

		//stringPlugins += ";" + navigator.plugins[n].description;
	}

	const strColor = window.screen.colorDepth ? window.screen.colorDepth : '';

	const strSystemLanguage = ''; // navigator.systemLanguage ? navigator.systemLanguage : '';

	const strBrowserLanguage = ''; // navigator.browserLanguage ? navigator.browserLanguage : '';

	const strUserLanuage = ''; // navigator.userLanguage ? navigator.userLanguage : '';

	const strCpuClass = ''; // navigator.cpuClass ? navigator.cpuClass : '';

	const strPlatform = navigator.platform ? navigator.platform : '';

	const strLanguage = navigator.language ? navigator.language : '';

	const fullString =
		navigator.userAgent +
		'|' +
		stringPlugins +
		'|' +
		window.screen.width +
		'x' +
		window.screen.height +
		'|' +
		strColor +
		'|' +
		strSystemLanguage +
		'|' +
		strBrowserLanguage +
		'|' +
		strUserLanuage +
		'|' +
		strCpuClass +
		'|' +
		strPlatform +
		'|' +
		strLanguage +
		'|' +
		getTimezoneName();

	return sha256(username + '|' + fullString);
}

/* Code provided by DSI and Luis (adjusted for TS) */
/* eslint-disable eqeqeq */
/* eslint-disable sonarjs/cognitive-complexity */
function getTimezoneName() {
	const timeSummer = new Date(Date.UTC(2005, 6, 30, 0, 0, 0, 0));
	const summerOffset = -1 * timeSummer.getTimezoneOffset();
	const timeWinter = new Date(Date.UTC(2005, 12, 30, 0, 0, 0, 0));
	const winterOffset = -1 * timeWinter.getTimezoneOffset();
	let timeZoneHiddenField;

	if (-720 == summerOffset && -720 == winterOffset) {
		timeZoneHiddenField = 'Dateline Standard Time';
	}
	// else if (-660 == summerOffset && -660 == winterOffset) { timeZoneHiddenField = 'UTC-11'; }
	else if (-660 == summerOffset && -660 == winterOffset) {
		timeZoneHiddenField = 'Samoa Standard Time';
	} else if (-660 == summerOffset && -600 == winterOffset) {
		timeZoneHiddenField = 'Hawaiian Standard Time';
	} else if (-570 == summerOffset && -570 == winterOffset) {
		timeZoneHiddenField = 'Pacific/Marquesas';
	}
	//                else if (-540 == summerOffset && -600 == winterOffset) { timeZoneHiddenField.value = 'America/Adak'; }
	//                else if (-540 == summerOffset && -540 == winterOffset) { timeZoneHiddenField.value = 'Pacific/Gambier'; }
	else if (-480 == summerOffset && -540 == winterOffset) {
		timeZoneHiddenField = 'Alaskan Standard Time';
	}
	//                else if (-480 == summerOffset && -480 == winterOffset) { timeZoneHiddenField = 'Pacific/Pitcairn'; }
	else if (-420 == summerOffset && -480 == winterOffset) {
		timeZoneHiddenField = 'Pacific Standard Time';
	} else if (-420 == summerOffset && -420 == winterOffset) {
		timeZoneHiddenField = 'US Mountain Standard Time';
	} else if (-360 == summerOffset && -420 == winterOffset) {
		timeZoneHiddenField = 'Mountain Standard Time';
	} else if (-360 == summerOffset && -360 == winterOffset) {
		timeZoneHiddenField = 'Central America Standard Time';
	}
	//                else if (-360 == summerOffset && -300 == winterOffset) { timeZoneHiddenField = 'Pacific/Easter'; }
	else if (-300 == summerOffset && -360 == winterOffset) {
		timeZoneHiddenField = 'Central Standard Time';
	} else if (-300 == summerOffset && -300 == winterOffset) {
		timeZoneHiddenField = 'SA Pacific Standard Time';
	} else if (-240 == summerOffset && -300 == winterOffset) {
		timeZoneHiddenField = 'Eastern Standard Time';
	} else if (-270 == summerOffset && -270 == winterOffset) {
		timeZoneHiddenField = 'Venezuela Standard Time';
	} else if (-240 == summerOffset && -240 == winterOffset) {
		timeZoneHiddenField = 'SA Western Standard Time';
	} else if (-240 == summerOffset && -180 == winterOffset) {
		timeZoneHiddenField = 'Central Brazilian Standard Time';
	} else if (-180 == summerOffset && -240 == winterOffset) {
		timeZoneHiddenField = 'Atlantic Standard Time';
	} else if (-180 == summerOffset && -180 == winterOffset) {
		timeZoneHiddenField = 'Montevideo Standard Time';
	} else if (-180 == summerOffset && -120 == winterOffset) {
		timeZoneHiddenField = 'E. South America Standard Time';
	} else if (-150 == summerOffset && -210 == winterOffset) {
		timeZoneHiddenField = 'Mid-Atlantic Standard Time';
	} else if (-120 == summerOffset && -180 == winterOffset) {
		timeZoneHiddenField = 'America/Godthab';
	} else if (-120 == summerOffset && -120 == winterOffset) {
		timeZoneHiddenField = 'SA Eastern Standard Time';
	} else if (-60 == summerOffset && -60 == winterOffset) {
		timeZoneHiddenField = 'Cape Verde Standard Time';
	} else if (0 == summerOffset && -60 == winterOffset) {
		timeZoneHiddenField = 'Azores Daylight Time';
	} else if (0 == summerOffset && 0 == winterOffset) {
		timeZoneHiddenField = 'Morocco Standard Time';
	} else if (60 == summerOffset && 0 == winterOffset) {
		timeZoneHiddenField = 'GMT Standard Time';
	} else if (60 == summerOffset && 60 == winterOffset) {
		timeZoneHiddenField = 'Africa/Algiers';
	} else if (60 == summerOffset && 120 == winterOffset) {
		timeZoneHiddenField = 'Namibia Standard Time';
	} else if (120 == summerOffset && 60 == winterOffset) {
		timeZoneHiddenField = 'Central European Standard Time';
	} else if (120 == summerOffset && 120 == winterOffset) {
		timeZoneHiddenField = 'South Africa Standard Time';
	} else if (180 == summerOffset && 120 == winterOffset) {
		timeZoneHiddenField = 'GTB Standard Time';
	} else if (180 == summerOffset && 180 == winterOffset) {
		timeZoneHiddenField = 'E. Africa Standard Time';
	} else if (240 == summerOffset && 180 == winterOffset) {
		timeZoneHiddenField = 'Russian Standard Time';
	} else if (240 == summerOffset && 240 == winterOffset) {
		timeZoneHiddenField = 'Arabian Standard Time';
	} else if (270 == summerOffset && 210 == winterOffset) {
		timeZoneHiddenField = 'Iran Standard Time';
	} else if (270 == summerOffset && 270 == winterOffset) {
		timeZoneHiddenField = 'Afghanistan Standard Time';
	} else if (300 == summerOffset && 240 == winterOffset) {
		timeZoneHiddenField = 'Pakistan Standard Time';
	} else if (300 == summerOffset && 300 == winterOffset) {
		timeZoneHiddenField = 'West Asia Standard Time';
	} else if (330 == summerOffset && 330 == winterOffset) {
		timeZoneHiddenField = 'India Standard Time';
	} else if (345 == summerOffset && 345 == winterOffset) {
		timeZoneHiddenField = 'Nepal Standard Time';
	} else if (360 == summerOffset && 300 == winterOffset) {
		timeZoneHiddenField = 'N. Central Asia Standard Time';
	} else if (360 == summerOffset && 360 == winterOffset) {
		timeZoneHiddenField = 'Central Asia Standard Time';
	} else if (390 == summerOffset && 390 == winterOffset) {
		timeZoneHiddenField = 'Myanmar Standard Time';
	} else if (420 == summerOffset && 360 == winterOffset) {
		timeZoneHiddenField = 'North Asia Standard Time';
	} else if (420 == summerOffset && 420 == winterOffset) {
		timeZoneHiddenField = 'SE Asia Standard Time';
	} else if (480 == summerOffset && 420 == winterOffset) {
		timeZoneHiddenField = 'North Asia East Standard Time';
	} else if (480 == summerOffset && 480 == winterOffset) {
		timeZoneHiddenField = 'China Standard Time';
	} else if (540 == summerOffset && 480 == winterOffset) {
		timeZoneHiddenField = 'Yakutsk Standard Time';
	} else if (540 == summerOffset && 540 == winterOffset) {
		timeZoneHiddenField = 'Tokyo Standard Time';
	} else if (570 == summerOffset && 570 == winterOffset) {
		timeZoneHiddenField = 'Cen. Australia Standard Time';
	} else if (570 == summerOffset && 630 == winterOffset) {
		timeZoneHiddenField = 'Australia/Adelaide';
	} else if (600 == summerOffset && 540 == winterOffset) {
		timeZoneHiddenField = 'Asia/Yakutsk';
	} else if (600 == summerOffset && 600 == winterOffset) {
		timeZoneHiddenField = 'E. Australia Standard Time';
	} else if (600 == summerOffset && 660 == winterOffset) {
		timeZoneHiddenField = 'AUS Eastern Standard Time';
	} else if (630 == summerOffset && 660 == winterOffset) {
		timeZoneHiddenField = 'Australia/Lord_Howe';
	} else if (660 == summerOffset && 600 == winterOffset) {
		timeZoneHiddenField = 'Tasmania Standard Time';
	} else if (660 == summerOffset && 660 == winterOffset) {
		timeZoneHiddenField = 'West Pacific Standard Time';
	} else if (690 == summerOffset && 690 == winterOffset) {
		timeZoneHiddenField = 'Central Pacific Standard Time';
	} else if (720 == summerOffset && 660 == winterOffset) {
		timeZoneHiddenField = 'Magadan Standard Time';
	} else if (720 == summerOffset && 720 == winterOffset) {
		timeZoneHiddenField = 'Fiji Standard Time';
	} else if (720 == summerOffset && 780 == winterOffset) {
		timeZoneHiddenField = 'New Zealand Standard Time';
	} else if (765 == summerOffset && 825 == winterOffset) {
		timeZoneHiddenField = 'Pacific/Chatham';
	} else if (780 == summerOffset && 780 == winterOffset) {
		timeZoneHiddenField = 'Tonga Standard Time';
	} else if (840 == summerOffset && 840 == winterOffset) {
		timeZoneHiddenField = 'Pacific/Kiritimati';
	} else {
		timeZoneHiddenField = 'US/Pacific';
	}
	return timeZoneHiddenField;
}

/* Code provided in: https://stackoverflow.com/a/48161723 */
async function sha256(message: string): Promise<string> {
	// Check if crypto.subtle is supported
	if (!window.crypto || !window.crypto.subtle) {
		// API not available at localhost (use local.mcp.cloud)
		// throw new Error('Web Crypto API not supported.');
		return '';
	}

	// encode as UTF-8
	const msgBuffer = new TextEncoder().encode(message);

	// hash the message
	const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

	// convert ArrayBuffer to Array
	const hashArray = Array.from(new Uint8Array(hashBuffer));

	// convert bytes to hex string
	return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('');
}
